import React from 'react';

const ArtemisIntegrations = () => {
  const integrations = [
    {
      category: 'IDEs & Editors',
      items: [
        { name: 'VS Code', icon: '💻' },
        { name: 'IntelliJ IDEA', icon: '🧠' },
        { name: 'PyCharm', icon: '🐍' },
        { name: 'Sublime Text', icon: '📝' },
        { name: 'Vim/Neovim', icon: '📋' }
      ]
    },
    {
      category: 'Version Control',
      items: [
        { name: 'GitHub', icon: '🐙' },
        { name: 'GitLab', icon: '🦊' },
        { name: 'Bitbucket', icon: '🪣' },
        { name: 'Azure DevOps', icon: '🔷' }
      ]
    },
    {
      category: 'CI/CD Pipelines',
      items: [
        { name: 'Jenkins', icon: '🎩' },
        { name: 'GitHub Actions', icon: '⚡' },
        { name: 'CircleCI', icon: '⭕' },
        { name: 'Travis CI', icon: '🔨' },
        { name: 'GitLab CI', icon: '🚀' }
      ]
    },
    {
      category: 'Languages & Frameworks',
      items: [
        { name: 'Python', icon: '🐍' },
        { name: 'JavaScript/TypeScript', icon: '📜' },
        { name: 'Java', icon: '☕' },
        { name: 'C++', icon: '⚙️' },
        { name: 'Go', icon: '🐹' },
        { name: 'Rust', icon: '🦀' }
      ]
    }
  ];

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px' }}>
      <h1 style={{ fontSize: '2.5em', marginBottom: '20px', color: '#333' }}>
        Artemis Integrations
      </h1>
      <p style={{ fontSize: '1.2em', color: '#666', marginBottom: '40px' }}>
        Seamlessly integrate Artemis into your development ecosystem
      </p>
      
      {integrations.map((section, index) => (
        <div key={index} style={{ marginBottom: '50px' }}>
          <h2 style={{ 
            fontSize: '1.8em', 
            marginBottom: '25px', 
            color: '#444',
            borderBottom: '2px solid #e0e0e0',
            paddingBottom: '10px'
          }}>
            {section.category}
          </h2>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', 
            gap: '15px' 
          }}>
            {section.items.map((item, itemIndex) => (
              <div key={itemIndex} style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                padding: '20px',
                borderRadius: '12px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '10px',
                color: 'white',
                boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                transition: 'all 0.3s',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 4px 10px rgba(0,0,0,0.1)';
              }}>
                <span style={{ fontSize: '2.5em' }}>{item.icon}</span>
                <span style={{ fontSize: '1em', fontWeight: '600', textAlign: 'center' }}>
                  {item.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ArtemisIntegrations; 